const BaseModule = require('../../90_utils/base/BaseModule');

class TopNav extends BaseModule {

	constructor(el, params) {

		super(el);

		// element vars

		this.$collapsed          	= this.$el.find('.top-nav--collapsed');
		this.$expanded				= this.$el.find('.top-nav--expanded');

		this.$burger  				= this.$el.find('.nav-items--right .burger');
		this.$close  				= this.$el.find('.nav-items--right .close');
		this.$yir 					= this.$el.find('.nav-items--yir');

		this.$currentNavItem;
		this.$window  				= $(window);

		this.stickyScrollPos     	= -1;
		this.isAnimating        	= false;
		this.isTransitionLocked 	= false;
		this.scrollTop				= 0;

		this.isSiteLoaded 			= false;

		// save original settings

		if(!this.$yir.attr('data-href')){
			this.$yir.attr('data-href', this.$yir.find('a').attr('href'));
			this.$yir.attr('data-title', this.$yir.find('.title').text());
		}

		CustomEase.create("underline", "M0,0 C0.358,0.158 0.094,0.986 1,1");
	}

	// private methods

	_domReady(){

	}

	_addListeners(){

		this.$burger.on('click', $.proxy(this._onBurgerClick, this));
		this.$close.on('click', $.proxy(this._onCloseClick, this));

		this.$el.on('open', this.open.bind(this));
		this.$el.on('close', this.close.bind(this));

		this.$el.find('.nav-items .nav-item').on('mouseenter', $.proxy(this._onNavItemOver, this));
		this.$el.find('.nav-items .nav-item').on('mouseleave', $.proxy(this._onNavItemOut, this));
		this.$el.find('.nav-items .nav-item').on('click', $.proxy(this._onNavItemClick, this));

		this.$window.on('scroll', $.proxy(this._onScroll, this));

		window.vent.on('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.on('heroChangeRoute', this._onHeroChangeRoute, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
		window.vent.on('pageChangeComplete', this._onPageChangeComplete, this);

	}

	_removeListeners(){

	}

	// element event listeners

	_onBurgerClick(e){
		this.open();
	}

	_onCloseClick(e){
		this.close();
	}

	_onScroll(e){

		let scrollTop = Math.round(this.$window.scrollTop());

		if(scrollTop >= window.SETTINGS.coords.winHeight / 4 * 3){

			if(!this.$el.hasClass('is-sticky') && !this.isAnimating){

				$('body').addClass('sticky-nav');

				this.isAnimating = true;
				this.$el.addClass('is-sticky');

				TweenMax.to($('.progress-bar'), 0.3, {y:60, ease:'fade'});
				TweenMax.fromTo(this.$collapsed, 0.3, {y:-60}, {y:0, ease:'fade', onComplete:() => {
					this.isAnimating = false;
					this._onScroll();
				}});
			}
		}
		else {

			if(this.$el.hasClass('is-sticky') && !this.isAnimating && !this.isTransitionLocked){

				this.isAnimating = true;

				TweenMax.to($('.progress-bar'), 0.2, {y:0, ease:Cubic.easeOut});
				TweenMax.to(this.$collapsed, 0.3, {y:-60, ease:'fade', onComplete:() => {

					$('body').removeClass('sticky-nav');

					this.isAnimating = false;
					this.$el.removeClass('is-sticky');

					TweenMax.fromTo(this.$el, 0.2, {opacity:0}, {opacity:1, ease:Cubic.easeOut});
					TweenMax.set(this.$collapsed, {y:0});

					this._onScroll();
				}});
			}
		}
	}

	_onNavItemOver(e){

		let $target = $(e.currentTarget);
		this._navItemEnter($target);
	}

	_onNavItemOut(e){

		let $target = $(e.currentTarget);
		this._navItemLeave($target);
	}

	_onNavItemClick(e){

		let $target = $(e.currentTarget);
	}

	_onPageChangeStart(){
		this._checkRoute();
		this._changeYirOut();
		this.close();
	}

	_onHeroChangeRoute(){
		this.isTransitionLocked = true;
	}

	_onPageChangeComplete(){

		if(this.isTransitionLocked){

			let onScroll = () => {
				if(this.$window.scrollTop() >= window.SETTINGS.coords.winHeight){
					this.isTransitionLocked = false;
					this.$window.off('scroll', onScroll);
				}
			}

			this.$window.on('scroll', onScroll);
		}

		this._changeYirIn();
	}

	_onSiteLoadComplete(){
		this.isSiteLoaded = true;
		this._checkRoute();
	}

	//

	_changeYirOut(){

		let title = this._getYirTitle();

		if(title && this.$yir.find('.title').text() !== title){
			TweenMax.killTweensOf(this.$yir);
			TweenMax.to(this.$yir, 0.3, {opacity: 0, ease:'fade'});
		}
	}

	_changeYirIn(){
		let title = this._getYirTitle();
		this._setYirTitle(title);
	}

	_getYirTitle(){

		let router = window.SETTINGS.router;
		let pageId = router.getRouteObj().pageId;
		let title = this.$el.find(`.nav-item[data-id=\"${pageId}\"]`).find('.title').text();

		if(pageId === 'intro' || window.SETTINGS.breakpoint.minWidth('screen-medium')){
			title = this.$yir.attr('data-title');
		}

		return title;
	}

	_setYirTitle(title){

		let router = window.SETTINGS.router;
		let href = router.getRoute();
		let pageId = router.getRouteObj().pageId;

		if(pageId === 'intro' || window.SETTINGS.breakpoint.minWidth('screen-medium')){
			href = this.$yir.attr('data-href');
		}

		if(title && this.$yir.find('.title').text() !== title){
			this.$yir.find('.yir').attr('href', href);
			this.$yir.find('.title').text(title);
		}

		TweenMax.killTweensOf(this.$yir);
		TweenMax.to(this.$yir, 0.3, {opacity: 1, ease:'fade'});
	}

	//

	_navItemEnter($target){

		if(this.isSiteLoaded){

			let $underline = $target.find('.underline');

			TweenMax.killTweensOf($underline);
			TweenMax.to($underline, 0.24, {opacity: 1, ease:Cubic.easeOut});
			TweenMax.to($underline, 0.24, {scaleY: 1, y:0, ease:"underline"});
		}
	}

	_navItemLeave($target){

		if(!$target.hasClass('is-active')){

			let $underline = $target.find('.underline');

			TweenMax.killTweensOf($underline);
			TweenMax.to($underline, 0.2, {opacity: 0, ease:"underline", onComplete:() => {
				TweenMax.set($underline, {clearProps: 'all'});
			}});
		}
	}

	_checkRoute(){

		let routeObj = window.SETTINGS.router.getRouteObj();
		let $selectedNavItem = this.$el.find(`.nav-items ul > [data-id='${routeObj.pageId}']`);

		if(!this.$currentNavItem || !$selectedNavItem.hasClass('is-active')){

			if(this.$currentNavItem){
				this.$currentNavItem.removeClass('is-active');
				this._navItemLeave(this.$currentNavItem);
			}

			this._navItemEnter($selectedNavItem);

			this.$currentNavItem = $selectedNavItem;
			this.$currentNavItem.addClass('is-active');
		}
	}

	// open / close

	open(){

		if ( !this.$collapsed.hasClass('is-open') ) {
			// this.$collapsed.addClass('is-open');
		}

		this.$expanded.triggerHandler('open');
	}

	close(){

		if ( this.$collapsed.hasClass('is-open') ) {
			// this.$collapsed.removeClass('is-open');
		}

		this.$expanded.triggerHandler('close');
	}

	//

	_domUpdate(){
		this._updateHeroCoords();
	} // use me!

	_resize(){

		this._updateHeroCoords();

		let title = this._getYirTitle();
		this._setYirTitle(title);

	} // use me!

	_updateHeroCoords(){

		let $heroes = $('.hero:not(.is-hidden)');
		let $topHero;
		let topOffset;

		$heroes.each((index, value) => {

			let $hero = $(value);
			let offset = $hero.offset();

			if(isNaN(topOffset) || (offset.top < topOffset && offset.top >= 0)){
				topOffset = offset.top;
				$topHero = $hero;
			}
		});

		if($topHero && $topHero.length){
			this._onScroll();
		}
	}
}

module.exports = TopNav;
